import React, { Component } from 'react';
import {Link, browserHistory } from 'react-router';
import Loading from 'components/LoadingComponent';
import Footer from 'components/FooterComponent';
import Navigator from 'components/NavigatorComponent';
import Category from 'components/CategoryComponent';
import Slider from "react-slick";
import LazyLoad from 'react-lazy-load';
import API from 'sources/API';

require('slick-carousel/slick/slick.scss')
require('slick-carousel/slick/slick-theme.scss')
require('./Store.scss');
require('./Products.scss');
require('./SearchWrap.scss');

import FeatureStore from 'stores/FeatureStore';
import FeatureActions from 'actions/FeatureActions';
import ProductStore from 'stores/ProductStore';
import ProductActions from 'actions/ProductActions';

class StoreComponent extends Component{
  constructor(props) {
    super(props);
    let featureStore = FeatureStore.getState();
    let productStore = ProductStore.getState();
    this.state = {
      slides: productStore.slides,
      products: productStore.products,
      categoryList: featureStore.features,
      fixed: true,
      hasMore: productStore.hasMore,
      loading: productStore.loading,
      type: productStore.type,
      cid: null,
      fetchTimeOut: null,
      showNavigator: false
    };
    this.onCategoryChange = this.onCategoryChange.bind(this); // 数据有变
    this.onProductsChange = this.onProductsChange.bind(this);
    this.onProductScroll = this.onProductScroll.bind(this);
    this.onFeatureChange = this.onFeatureChange.bind(this);
    this.selectType = this.selectType.bind(this);
    this.loadMore = this.loadMore.bind(this)
  }
  componentWillMount() {
    if(!this.state.categoryList.length){
      FeatureActions.fetchFeatures();
    }
    if(!this.state.slides.length){
      ProductActions.fetchSlides();
    }
    if(!this.state.products.length){
      ProductActions.fetchProducts();
    }
  }
  selectType(type){
    if(this.state.type != type){
      if(!type){
        ProductActions.clearType();
        ProductActions.clearProducts();
        ProductActions.fetchProducts();
      }else if(type == 'hot'){
        ProductActions.updateFetchType('hot');
        ProductActions.clearProducts();
        ProductActions.fetchProducts();
      }else if(type == 'priceup'){
        ProductActions.updateFetchType('priceup');
        ProductActions.clearProducts();
        ProductActions.fetchProducts();
      }else if(type == 'pricedown'){
        ProductActions.updateFetchType('pricedown');
        ProductActions.clearProducts();
        ProductActions.fetchProducts();
      }
    }
  }
  componentDidMount(){
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        if(json.appId) {
          window.wx.config(json);
        }
      })
    }

    let productStore = ProductStore.getState();
    window.scrollTo(0, productStore.offset);
    window.addEventListener('scroll',this.onProductScroll);

    FeatureStore.listen(this.onCategoryChange);
    ProductStore.listen(this.onProductsChange);

    window.wx.ready(()=>{
      let imgUrl = 'https://img.xiaodiqiu.cn/share.png';
      window.wx.onMenuShareTimeline({
        title: `加入小地球旅行，发现本星球最有趣的地方`,
        link: location.href,
        imgUrl: imgUrl
      });
      window.wx.onMenuShareAppMessage({
        title: `小地球旅行`,
        desc: '加入小地球旅行，发现本星球最有趣的地方',
        link: location.href,
        type: 'link'
      });
    });

    window._hmt.push(['_trackPageview', this.props.location.pathname]);
    window.changeMetaForSEO(false);
  }
  componentWillUnmount(){
    ProductActions.updateProductOffset($(document).scrollTop());
    window.removeEventListener('scroll',this.onProductScroll);

    FeatureStore.unlisten(this.onCategoryChange);
    ProductStore.unlisten(this.onProductsChange);
  }
  onCategoryChange(state){
    this.setState({
      categoryList: state.features
    })
  }
  onProductsChange(state){
    this.setState({
      loading: state.loading,
      hasMore: state.hasMore,
      products: state.products,
      slides: state.slides,
      type: state.type
    })
  }
  onFeatureChange(feature){
    this.state.cid = feature._id;
  }
  onProductScroll(event) {
    if(this.state.fetchTimeOut) {
      clearTimeout(this.state.fetchTimeOut);
    }
    let scrollTop = $(document).scrollTop();
    let clientHeight = event.srcElement.body.clientHeight;
    let scrollHeight = event.srcElement.body.scrollHeight;
    if(scrollTop + clientHeight === scrollHeight) {
      ProductActions.setLoading(true);
      this.setState({fetchTimeOut: setTimeout(ProductActions.fetchProducts, 1000)});
    }
    if(scrollTop > 500){
      this.setState({showNavigator:true});
    }else{
      this.setState({showNavigator:false});
    }
  }
  loadMore() {
    ProductActions.setLoading(true);
    ProductActions.fetchProducts()
  }
  render(){
    let navigator;
    if(this.state.showNavigator){
      navigator = <Navigator action='top' />;
    }
    let settings = {
      autoplaySpeed: 2000,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false
    };
    return (
      <div className="store-component">
        <div className="search-input-wrap">
          <input className="search-input" placeholder="搜索" onClick={() => {browserHistory.push('/search')}} />
        </div>
        <Category 
          category={this.state.categoryList} 
          fixed={this.state.fixed} 
          cid={this.state.cid} 
          type="feature" 
          top="44px" 
          onFeatureChange={this.onFeatureChange} 
          />
        <Slider {...settings} className="slider-wrap">
          {this.state.slides&&this.state.slides.map(function(slide){
            return <div className="slide-warp" key={slide._id}>
              <a href={slide.url}>
                <img className="slide" src={slide.cover}></img>
                <div className="slide-title">{slide.title}</div>
              </a>
            </div>;
          })}
        </Slider>
        <div className="rank-menu fz-12">
          <button className={!this.state.type?'rank-item active':'rank-item'} onClick={this.selectType.bind(this,'')}>综合</button>
          <button className={this.state.type=='hot'?'rank-item active':'rank-item'} onClick={this.selectType.bind(this,'hot')}>热门</button>
          <button className="rank-item teams" onClick={() => { browserHistory.push('/teams')}}>所有团期</button>
          <button
            className={(this.state.type=='priceup'||this.state.type=='pricedown')?'rank-item price right active':'rank-item price right'}
            onClick={this.selectType.bind(this,this.state.type=="pricedown"?'priceup':'pricedown')}>
              <i className={this.state.type=="pricedown"?'fa fa-sort-amount-desc':'fa fa-sort-amount-asc'} aria-hidden="true"></i>价格
          </button>
        </div>
        <div className="products">
          {this.state.products&&this.state.products.map(function(product){
            return (<Link to={`/route/${product._id}`} key={product._id} className="product">
            <LazyLoad throttle={50} debounce={true}><img className="cover" src={product.cover.big}></img></LazyLoad>
            <div className="pd-10">
              <div className="float left left-content">
                <div className="title">{product.title}</div>
                <div className="price mt-5">¥{product.price}&nbsp;起</div>
              </div>
              <div className="float right">
                <button className="tag fz-10">{product.feature.name?product.feature.name:'博物'}</button>
              </div>
              <div className="clear"></div>
            </div>
          </Link>)
          })}
        </div>
        <Loading loading={this.state.loading} hasMore={this.state.hasMore} loadMore={this.loadMore} />
        {navigator}
        <Footer activeTab='store'/>
      </div>
    );
  }
}

export default StoreComponent;




// WEBPACK FOOTER //
// ./src/develop/StoreComponent.js